import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { MemberRole } from './members/members-models';

@Injectable({
  providedIn: 'root'
})
export class CommonApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(ConfigService);


  getMembersRolesOnLogin(token: string): Observable<MemberRole> {
    const HEADERS = {
      Authorization: `Bearer ${token}`
    };
    return this.httpClient.get<MemberRole>(`${this.config.apiUrl}/members/roles`, { headers: HEADERS });
  }
}
